import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('/dicts/', data));

/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('/dicts/', { data: ids }));

/**
 * get getAdInfo
 */
export const getDictInfo = id => axios.$callAPI(() => axios.get('/dicts/' + id));

/**
 * get DictArticleList
 */
export const getDictArticleList = () => axios.$callAPI(() => axios.get('/dicts/article'));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('/dicts/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('/dicts/' + id));

/**
 * get list
 */
export const getDictList = data => axios.$callAPI(() => axios.get('/dicts/search', { params: data }));
